// A loop rather than a /\/+$/ regex, which backtracks (quadratic) on a long run
// of slashes that is not at the end of the string.
const stripTrailingSlashes = (value) => {
  let end = value.length;
  while (end > 0 && value[end - 1] === '/') end -= 1;
  return value.slice(0, end);
};

const normalizeMenuUrl = (url) =>
  typeof url === 'string' ? stripTrailingSlashes(url.trim().toLowerCase()) : '';

/**
 * Menu URLs to hide from the side nav, from REACT_APP_HIDDEN_MENU_URLS
 * (comma-separated, e.g. '/copy-client-hierarchy, /some-other-page'). Unset or
 * empty hides nothing. URLs are compared trimmed, case-insensitively and without
 * a trailing slash, against the `url` the appcore menus API returns.
 *
 * A URL is stable across a rename in the Admin Menus tool, unlike the title, and
 * an item with no url (such as an 'open' parent) never matches.
 *
 * Read on each call (not at module load) so tests can change the env var. Call it
 * once per menu and pass the result to isMenuHidden, not once per item.
 */
export const getHiddenMenuUrls = () =>
  new Set(
    (process.env.REACT_APP_HIDDEN_MENU_URLS || '')
      .split(',')
      .map(normalizeMenuUrl)
      .filter(Boolean),
  );

export const isMenuHidden = (url, hiddenUrls) =>
  hiddenUrls.has(normalizeMenuUrl(url));
